import { RESOURCES_COVERIZABLE_OBJECT_TYPE_VALUE_HOLDERS } from "@raiden/library/constants/resources";
import CoverModal from "@raiden/library/containers/Covers/CoverModal";

/**
 * @typedef {Object} Props
 * @property {boolean} isLoading
 * @property {boolean} isOpen
 * @property {() => void} onClose
 *
 * @param {Props} props
 */
function HoldersUpdateCoverForm({ isLoading, isOpen, onClose }) {
  return (
    <CoverModal
      isLoading={isLoading}
      isOpen={isOpen}
      onClose={onClose}
      coverName="id_card"
      transformationsName="data.id_card.transformations"
      objectType={RESOURCES_COVERIZABLE_OBJECT_TYPE_VALUE_HOLDERS}
      withLegend={false}
    />
  );
}

export default HoldersUpdateCoverForm;
